// extracted by mini-css-extract-plugin
module.exports = {"location":"icon-row_location__3ywKf typography_bodyFont__2-Mbk","pinIcon":"icon-row_pinIcon__2tQ9u"};